import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import viewRelatedRoomTags from './viewRelatedRoomTags';

export default {
  title: 'General values',
  attributeName: 'sportsRoom',
  fields: [
     {
      attributeName: 'discoverable',
      helpText: 'Discoverable.',
      type: FormInputTypes.CHECKBOX,
      label: 'Discoverable',
      default : false,
    },
    {
      attributeName: 'displayName',
      label: 'Display Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Optional name for showing instead of the internal name'
    },
    {
      attributeName: 'appTags',
      label: 'Tags',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: true,
      canCreate: true,
      configFile: viewRelatedRoomTags,
      default: [],
      helpText: 'Tags related.',
    },
    {
      attributeName: 'id',
      label: 'Tags Preview',
      type: FormInputTypes.TAGS_PREVIEW,
      canEdit: true,
      canCreate: true,
      tagMode:"room",
      helpText: 'Tags preview.',
    },
    // {
    //   attributeName: 'logoUISquare',
    //   type: FormInputTypes.DOWNLOADABLE,
    //   label: 'Logo (Square)',
    //   hasSelect:false,
    //   helpText: 'This logo is used in calendar component under layouts.',
    //   fileType: ['.png'],
    //   aspectRatio: '1:1',    

    // },
  ],
};
